import { Component, OnInit, OnDestroy, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ClienteService } from '../../services/cliente.service';
import { CommonModule } from '@angular/common';
import { UserDetails } from '../../components/user-details/user-details.component';
import { SelectSystemComponent, SelectOption } from '../../components/select-system/select-system.component';
import { GenericButtonComponent } from '../../components/generic-button/generic-button.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Cliente } from '../../model/cliente.model';
import { UserService } from '../../services/user.service';
import { environment } from '../../../environments/environment';
import '@grupodemarco/dm-notification-center-sdk';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    UserDetails,
    SelectSystemComponent,
    GenericButtonComponent,
    BreadcrumbComponent,
    TranslatePipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {

  isAuthenticated = false;
  private authSub: Subscription | undefined;
  notificationToken = '';
  locale: string | null = null;
  notificationApiUrl = environment.notificationApiUrl;

  constructor(
    private readonly servicoAuth: AuthService,
    private readonly clienteService: ClienteService,
    private readonly userService: UserService
  ){ }
  clientes: Cliente[] = [];
  opcoesCliente: SelectOption[] = [];
  clienteSelecionado: string | null = null;
  
  ngOnInit(): void {
    this.notificationToken = this.getCookie('token') || '';
    const lang = localStorage.getItem('language') || 'pt';
    this.locale = lang === 'pt' ? null : lang;

    this.authSub = this.servicoAuth.authStatus$.subscribe(
      (status) => {
        this.isAuthenticated = status;
        if (status) {
          this.userService.loadUserProfile();
          this.notificationToken = this.getCookie('token') || '';
        }
      }
    );
    this.servicoAuth.init(); // Atualiza o status após inicializar Autenticacao
    this.carregarClientes();
  }

  ngOnDestroy(): void {
    this.authSub?.unsubscribe();
  }
  
  login(){
    this.servicoAuth.login();
  }

  logout() {
    this.servicoAuth.logout();
    console.log('Clicou em sair')
  }

  carregarClientes(): void {
    this.clienteService.getClientes().subscribe({
      next: (response) => {
        if (response.success) {
          this.clientes = response.usuario_data;
          this.opcoesCliente = this.clientes.map(cliente => ({
            valor: cliente.idcliente.toString(),
            nome: cliente.nomecliente
          }));
        }
      },
      error: (error) => {
        console.error('Erro ao carregar clientes:', error);
      }
    });
  }

  onClienteSelecionadoChange(valor: string) {
    this.clienteSelecionado = valor;
    const cliente = this.clientes.find(c => c.idcliente.toString() === valor);
    if (cliente) {
      console.log('Cliente selecionado:', cliente.nomecliente);
    }
  }

  private getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

}
